import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';
import { Switch } from './../../models/editors/switch.model';

import { Page } from './../../models/pages/pages.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { ContainedMany } from './../../models/editors/contained-many.model';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

@Component({
  selector: 'swb-page-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class PageDetailComponent extends FormDetailBase<Page> implements OnInit {
  public url = 'pages';
  protected _redirect = './pages';

  public entity = new Page({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název stránky',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Switch({
        key: 'has_custom_title',
        label: 'Vlastní nadpis stránky',
        isMultilang: true,
        labelFalse: 'Nadpis stránky stejný jako titulek'
      }),
      new Textbox({
        key: 'custom_title',
        label: 'Vlastní nadpis stránky',
        isMultilang: true,
        boundTo: 'has_custom_title'
      }),
      new Textarea({
        key: 'content_top',
        label: 'Horní obsah stránky',
        validators: [],
        isMultilang: true,
        wysiwyg: 'page-detail',
        width: 2
      }),
      new Textarea({
        key: 'content',
        label: 'Hlavní obsah stránky',
        validators: [],
        isMultilang: true,
        wysiwyg: 'page-detail',
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        validators: [],
        isMultilang: true,
        wysiwyg: false,
        boundTo: 'custom_seo_data'
      }),
      new ContainedMany({
        key: 'files',
        label: 'Galerie',
        entities: this.entity.files,
        files: this.entity.files,
        apiUrl: 'files',
        upload: true,
        imgOnly: false
      }),
      new ContainedMany({
        key: 'gallery_images',
        label: 'Horní Galerie',
        entities: this.entity.gallery_images,
        files: this.entity.gallery_images,
        apiUrl: 'files',
        upload: true,
        imgOnly: true
      }),
      new ContainedMany({
        key: 'pagetiles',
        label: 'Navigační dlaždice',
        entities: this.entity.tiles,
        upload: false,
        apiUrl: 'pagetiles',
        canCreate: true
      }),
      new ContainedMany({
        key: 'contentboxes',
        label: 'Obsahové boxy',
        entities: this.entity.contentboxes,
        upload: false,
        apiUrl: 'contentboxes',
        canCreate: true
      }),
      new Switch({
        key: 'boxes_zigzag',
        label: 'Střídat zarovnání obsahu boxů vlevo/vpravo',
        isMultilang: false,
        labelFalse: 'Zarovnat všechen obsah boxů doleva',
        defaultValue: true
      }),
      new ContainedMany({
        key: 'designboxes',
        label: 'Designové boxy',
        entities: this.entity.designboxes,
        upload: false,
        apiUrl: 'designboxes',
        canCreate: true
      }),
      new ContainedMany({
        key: 'storyboards',
        label: 'Storyboardy',
        entities: this.entity.storyboards,
        upload: false,
        apiUrl: 'storyboards',
        canCreate: true
      }),
      new Contained({
        key: 'form_id',
        label: 'Formulář',
        entity: this.entity.form,
        upload: false,
        apiUrl: 'forms'
      }),
      new ContainedMany({
        key: 'appointment_calendars', // TODO: condition
        label: 'Kalendáře',
        entities: this.entity.appointment_calendars,
        upload: false,
        apiUrl: 'appointment-calendars',
        canCreate: false
      }),
      new ContainedMany({
        key: 'booking-offers', // TODO: condition
        label: 'Rezervace položek',
        entities: this.entity.booking_offers,
        upload: false,
        apiUrl: 'booking-offers',
        canCreate: false
      }),
      new Switch({
        key: 'is_contact_page',
        label: 'Stránka s kontakty',
        labelFalse: 'Nezobrazovat kontakty'
      }),
      new Switch({
        key: 'has_certs',
        label: 'Stránka s certifikáty',
        labelFalse: 'Nezobrazovat certifikáty'
      }),
      new Switch({
        key: 'has_grants',
        label: 'Stránka s granty',
        labelFalse: 'Nezobrazovat granty'
      }),
      new Switch({
        key: 'has_career',
        label: 'Stránka s kariérou',
        labelFalse: 'Nezobrazovat kariéru'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
